import { useState } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { Image } from 'foundations-components/transitional/components/Image';
import HubSpotVideoPlayer from 'ui-addon-video-player/components/HubSpotVideoPlayer';
import { CalloutButton } from './CalloutButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MEDIA_BLOCK_SIZE = '200px';
export function CalloutCard({
  title,
  buttonText,
  buttonUrl,
  imageUrl,
  imageAlt = '',
  videoId,
  videoInteractive = false,
  onClick,
  openCopilot,
  CtaButton = CalloutButton
}) {
  // A video always wins when present; if the player reports an error we fall
  // back to the still image (or placeholder). We track the id that failed
  // (rather than a boolean synced via an effect), so a prior failure is
  // derived away in-render the moment a new/corrected id arrives.
  const [failedVideoId, setFailedVideoId] = useState();
  const videoFailed = failedVideoId != null && failedVideoId === videoId;
  const showVideo = videoId != null && !videoFailed;
  const mediaContent = showVideo ? /*#__PURE__*/_jsx(Flex, {
    blockSize: MEDIA_BLOCK_SIZE,
    flexShrink: 0,
    inlineSize: "100%",
    overflow: "hidden",
    position: "relative",
    children: /*#__PURE__*/_jsx(View, {
      position: "absolute",
      insetBlockStart: "0",
      insetBlockEnd: "0",
      insetInlineStart: "-1px",
      insetInlineEnd: "0",
      pointerEvents: videoInteractive ? undefined : 'none',
      children: /*#__PURE__*/_jsx(HubSpotVideoPlayer, {
        videoId: videoId,
        autoPlay: false,
        mutedByDefault: true,
        objectFit: "cover",
        onError: () => setFailedVideoId(videoId)
      })
    })
  }) : imageUrl ? /*#__PURE__*/_jsx(Flex, {
    flex: "1",
    minBlockSize: MEDIA_BLOCK_SIZE,
    overflow: "hidden",
    children: /*#__PURE__*/_jsx(Image, {
      alt: imageAlt,
      blockSize: "100%",
      inlineSize: "100%",
      loading: "lazy",
      objectFit: "cover",
      src: imageUrl
    })
  }) : /*#__PURE__*/_jsx(Flex, {
    flex: "1",
    minBlockSize: MEDIA_BLOCK_SIZE,
    overflow: "hidden",
    children: /*#__PURE__*/_jsx(View, {
      backgroundColor: "fill-accent-neutral-subtle-alt",
      blockSize: "100%",
      inlineSize: "100%"
    })
  });
  return /*#__PURE__*/_jsx(CardWrapper, {
    margin: "0",
    overflow: "hidden",
    blockSize: "100%",
    flex: "1",
    children: /*#__PURE__*/_jsx(CardSection, {
      padding: "0",
      margin: "0",
      blockSize: "100%",
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        blockSize: "100%",
        minBlockSize: "0",
        children: [mediaContent, /*#__PURE__*/_jsxs(Flex, {
          alignItems: "start",
          backgroundColor: "fill-surface-default",
          flexDirection: "column",
          gap: "300",
          justifyContent: "center",
          padding: "400",
          flexShrink: 0,
          position: "relative",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h5",
            typography: "heading-400",
            children: title
          }), /*#__PURE__*/_jsx(CtaButton, {
            buttonText: buttonText,
            buttonUrl: buttonUrl,
            onClick: onClick,
            openCopilot: openCopilot,
            use: "tertiary-extra-light"
          })]
        })]
      })
    })
  });
}